// React
import React from "react";
// Styles
import styles from "./NoResults.css";

const NoResults = ({ message }) => <div style={styles.container}>{message}</div>;

export default NoResults;
